import { HttpHeaders } from '@angular/common/http';
import { v4 as uuid } from 'uuid';

export const CONTENT_TYPE = 'application/json';
export const REQUEST_TIMEOUT_IN_SECONDS = '30';

export function getHttpHeaders(): HttpHeaders {
    return new HttpHeaders()
        .set('content-type', CONTENT_TYPE)
        .set('request-id', uuid())
        .set('request-time', new Date().toISOString())
        .set('request-timeout-in-seconds', REQUEST_TIMEOUT_IN_SECONDS);
}

export function getHttpHeadersWithTractId(): HttpHeaders {
    return new HttpHeaders()
    .set('Accept', CONTENT_TYPE)
    .set('Authorization', 'Bearer AAIkMzkwNmRkNmQtNTM0Yi00ZDIwLTgxZD')
    .set('request-id', uuid())
    .set('request-time', new Date().toISOString())
    .set('request-timeout-in-seconds', REQUEST_TIMEOUT_IN_SECONDS)
    .set('Trace-Id', uuid());
}

export function getHttpHeadersForFile(): HttpHeaders {
    return new HttpHeaders()
        // .set('ngsw-bypass', 'true')
        .set('Request-Id', uuid())
        .set('Request-Time', new Date().toISOString())
        .set('Request-Timeout-In-Seconds', REQUEST_TIMEOUT_IN_SECONDS);
}

//---------------------------------------------------------------------
export const REGISTRATION_REF_ID = "registrationRefId";
export const OTP_EXPIRES_AT = "otpExpiresAt";
export const otpValidTimeInSec = "otpValidTimeInSec";
export const ibUserOid = "ibUserOid";
export const USER_ID = "userId";
export const SAVE_ID = "saveId";
export const REF_ID = "refId";
export const BENEFICIARY_TYPE = "ib";
export const BANK_ID = "010";
export const LANG = "lang";
export const CHANGEPASS_REF_ID = "changePassRefId";
export const LOGGED_IN_USER_INFO = "ib.web.user"
